import { render, staticRenderFns } from "./RolesEdit.vue?vue&type=template&id=289639e5&scoped=true"
import script from "./RolesEdit.vue?vue&type=script&lang=js"
export * from "./RolesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289639e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('289639e5')) {
      api.createRecord('289639e5', component.options)
    } else {
      api.reload('289639e5', component.options)
    }
    module.hot.accept("./RolesEdit.vue?vue&type=template&id=289639e5&scoped=true", function () {
      api.rerender('289639e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/roles/RolesEdit.vue"
export default component.exports